import {getPrimitive} from '@tickchak/react-share/app';
import {getDateFormat} from '../../../library/dates';
import store from '../../../store';
import {DEFAULT_TIME_ZONE} from '../../../globalVariables/locals';

const getEventTimeZone = (): string => store.getState().event?.timeZone || DEFAULT_TIME_ZONE;

export type PlanType = 'closed' | 'open' | 'mixed' | 'gift_card';
export const formatDate = (date?: string | number): string => {
    if(!date) return '';
    return getDateFormat(date, 'DD.MM.YY', getEventTimeZone());
};

export const formatDateTime = (date?: string | number): string => {
    if(!date) return '';
    return getDateFormat(date, 'DD.MM.YY HH:mm', getEventTimeZone());
};

export const seriesTypeLabel = {
    open: {color: getPrimitive('pinks.pink50'), label: 'openSeries'},
    closed: {color: getPrimitive('turquoise.turquoise100'), label: 'closedSeries'},
    mixed: {color: getPrimitive('greens.green50'), label: 'combinedSeries'},
    gift_card: {color: getPrimitive('yellow.yellow50'), label: 'giftCard'},
};
